import type { OutgoingStatisticsResponse } from '../../../store/reducers/OutgoingStatisticsSlice';

import type { OutgoingStatisticMetrics } from './outgoingStatisticMetrics';
import type { OutgoingStatisticRow } from './statisticRowTypes';
import {
  createFixedPercentMetricRow,
  createMetricRow,
} from './statisticRowFactory';

const SECTION = 'Общие показатели';

export const buildCommonRows = (
  statistic: OutgoingStatisticsResponse,
  metrics: OutgoingStatisticMetrics,
): OutgoingStatisticRow[] => [
  createFixedPercentMetricRow({
    key: 'common-tasksCount',
    section: SECTION,
    parameter: 'Всего заданий',
    value: metrics.totalTasksCount,
  }),
  createMetricRow({
    key: 'common-processedTasksCount',
    section: SECTION,
    parameter: 'Обработано заданий',
    value: metrics.processedTasksCount,
    denominator: metrics.totalTasksCount,
  }),
  createFixedPercentMetricRow({
    key: 'common-processedTasksAttemptCount',
    section: SECTION,
    parameter: 'Всего звонков по обработанным заданиям',
    value: metrics.processedTasksAttemptCount,
  }),
  createMetricRow({
    key: 'common-inProcessingTasksCount',
    section: SECTION,
    parameter: 'Заданий в обработке',
    value: statistic.inProcessingTasksCount,
    denominator: metrics.totalTasksCount,
  }),
  createMetricRow({
    key: 'common-notProcessedTasksCount',
    section: SECTION,
    parameter: 'В очереди на обработку',
    value: statistic.notProcessedTasksCount,
    denominator: metrics.totalTasksCount,
  }),
  createMetricRow({
    key: 'common-blockedTasksCount',
    section: SECTION,
    parameter:
      'Черный список (звонки на номер заблокированы, не было попыток дозвона)',
    value: statistic.blockedTasksCount,
    denominator: metrics.totalTasksCount,
  }),
];
